<template>
  <div>
    <Sidebar></Sidebar>
    <Header></Header>
    <b-container fluid>
      <b-row>
        <b-col>
          <h3 class="my-4">Usuários:</h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-table striped hover :items="items" :fields="fields">
            <template slot="editar" slot-scope="data">
              <a :href="'#/user/' + data.item.id">
                <i class="fas fa-edit"></i>
              </a>
            </template>
            <template slot="editar" slot-scope="data">
              <a :href="'#/usuario/' + data.item.id">
                <i class="fas fa-edit"></i>
              </a>
            </template>
            <template slot="approvalStatus" slot-scope="data">
              <span :style="statusColor(data.item.approvalStatus)">{{
                data.item.approvalStatus
              }}</span>
            </template>
            <template slot="excluir" slot-scope="data">
              <i
                @click="removeObj(data.item)"
                class="fas fa-trash-alt danger"
              ></i>
            </template>
          </b-table>
          <div v-show="loading" class="loading-holder">
            <div class="loading-spinner"></div>
          </div>
        </b-col>
      </b-row>

      <v-pagination
        class="f-right mt-3"
        v-model="currentPage"
        :page-count="pages"
      ></v-pagination>
    </b-container>
  </div>
</template>

<script>
import http from "@/http";
import router from "@/router";
import authentication from "../util/authentication";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Footer from "../components/Footer";
import vPagination from "vue-plain-pagination";

export default {
  name: "User",
  data() {
    return {
      entity: {
        eng: "User",
        por: "Usuário"
      },
      fields: [
        "editar",
        {
          key: "name",
          label: "Nome",
          sortable: false
        },
        {
          key: "email",
          label: "E-mail",
          sortable: false
        },
        {
          key: "permissionLevel",
          label: "Função",
          sortable: false
        },
        {
          key: "approvalStatus",
          label: "Status",
          sortable: true
        },
        {
          key: "registrationDate",
          label: "Data de Cadastro",
          sortable: false
        },
        "excluir"
      ],
      items: [],
      currentPage: 1,
      pages: 1,
      loading: true
    };
  },
  components: {
    Sidebar,
    Header,
    Footer,
    vPagination
  },
  methods: {
    statusColor(item) {
      if (item.toLowerCase() == "pendente") {
        return "color:#f60";
      } else if (item.toLowerCase() == "aprovado") {
        return "color:#3a3";
      } else {
        return "color:#f00";
      }
    },
    removeObj(obj) {
      if (
        confirm(
          `Tem certeza que deseja deletar o ${this.entity.por} ${obj.name}?`
        )
      ) {
        http
          .delete(`${this.entity.eng}/${obj.id}`, authentication.getHeaders())
          .then(response => {
            this.list();
          });
      }
    },
    list() {
      http
        .get(
          `${this.entity.eng}?page=${this.currentPage - 1}`,
          authentication.getHeaders()
        )
        .then(res => {
          this.items = res.data.list;
          this.pages = res.data.pages;
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    this.list();
  },
  watch: {
    currentPage() {
      this.list();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/User.vue